var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-underscore-dangle */
import { injectable } from 'inversify';
import { validate } from 'class-validator';
import { plainToClass, classToPlain } from 'class-transformer';
import { AppError } from '../error';
import { Logger } from '../logger';
let UnmarshallerService = class UnmarshallerService {
    constructor(logger) {
        this.logger = logger;
    }
    parseErrors(validationErrors, path = '') {
        return validationErrors.reduce((acc, error) => {
            var _a;
            if (!((_a = error.children) === null || _a === void 0 ? void 0 : _a.length)) {
                return [
                    ...acc,
                    {
                        [`${path}.${error.property}`]: error.constraints,
                    },
                ];
            }
            return [
                ...acc,
                ...this.parseErrors(error.children, `${path}.${error.property}`),
            ];
        }, []);
    }
    /** Выполнить приведение объекта свободной формы (поступающего из ответа сервера) к указанному типу конструктора
     * Валидация и логирование - это инструменты для этого приведения к типу конструктора.
     * @typeParam T - Тип конструктора
     * @param dto - Объект, проходящий проверку на соответствие классу
     * @param constructor - Класс для сравнения
     * @returns Возвращает инстанс переданного типа
     * */
    unmarshall(dto, constructor) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof dto !== 'object' || Array.isArray(dto) || dto === null) {
                if (window.REACT_APP_VKHRTEK_VALIDATE_RESPONSES.toString() === 'true') {
                    throw new AppError('client', {
                        code: 400,
                        message: 'Bad Request',
                        error: 'Bad Request',
                    });
                }
                try {
                    const tags = dto.__context__ || null;
                    this.logger.error('[validation] Invalid response dto', Object.assign(Object.assign({}, (tags ? { tags } : {})), { context: {
                            unmarshaller_dto: {
                                value: dto,
                            },
                        } }));
                }
                catch (e) {
                    this.logger.error(e);
                }
                this.logger.fatal('[validation] Invalid ');
            }
            else if (window.REACT_APP_VKHRTEK_VALIDATE_RESPONSES.toString() === 'true') {
                try {
                    const value = constructor
                        ? plainToClass(constructor, dto)
                        : dto;
                    const errors = yield validate(value);
                    if (errors === null || errors === void 0 ? void 0 : errors.length) {
                        const tags = dto.__context__ || null;
                        this.logger.warning(`[validation] Invalid response schema ${(tags === null || tags === void 0 ? void 0 : tags.http_method) ? `[${tags === null || tags === void 0 ? void 0 : tags.http_method}]` : ''} ${(tags === null || tags === void 0 ? void 0 : tags.http_url) || ''}`, Object.assign(Object.assign({}, (tags ? { tags } : {})), { context: Object.assign({ unmarshaller_errors: {
                                    value: this.parseErrors(errors),
                                } }, (constructor
                                ? {
                                    unmarshaller_value: constructor &&
                                        classToPlain(plainToClass(constructor, dto, {
                                            groups: ['sensitive'],
                                        })),
                                }
                                : {})) }));
                    }
                }
                catch (e) {
                    this.logger.fatal(e);
                }
            }
            return dto;
        });
    }
};
UnmarshallerService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [Logger])
], UnmarshallerService);
export { UnmarshallerService };
